module.exports = __webpack_public_path__ + "img/icon_page2_phone.453db6be.png";